export { loadContent } from '@molecule/app-locales-legal-default'

export const API_BASE_URL = import.meta.env?.VITE_API_URL || '/api'

/**
 * The Molecule.dev API this status page watches from OUTSIDE its infrastructure.
 * The page polls `${STATUS_API_BASE_URL}/health`, `/api/status/history`, and
 * `/api/status/rss`. Defaults to production; override with `VITE_STATUS_API_URL`
 * (e.g. a staging API) at build time.
 */
export const STATUS_API_BASE_URL =
  import.meta.env?.VITE_STATUS_API_URL || 'https://api.molecule.dev'

export const authConfig = {
  baseURL: API_BASE_URL,
  loginEndpoint: '/users/log-in',
  registerEndpoint: '/users',
  forgotPasswordEndpoint: '/users/forgot-password',
  resetPasswordEndpoint: '/users/reset-password',
  changePasswordEndpoint: '/users/me/password',
  // storage: 'memory' EXPLICITLY — @molecule/app-auth's browser default is Web Storage,
  // and a localStorage bearer copy is XSS-exfiltratable and defeats the httpOnly session
  // cookie [M1-1].
  storage: 'memory' as const,
  autoRefresh: true,
}

export const oauthConfig = {
  baseURL: API_BASE_URL,
  oauthProviders: [],
  oauthEndpoint: '/users/oauth',
}
